<template>
  <dialog-template 
    :headerTitle="'删除商品'" 
    :visible.sync="dialogVisible"
    :append-to-body="true"
    :width="'400px'">
    <p class="question text-popper" v-textPopper>确定删除商品 <span>{{ options.goods_name }}</span> 吗？</p>
    <p class="tips">删除后该商品将不可再次出售，商品会从后台移除</p>
    <div class="btn-wrapper" slot="footer">
        <el-button :loading="loading" type="danger" size="medium" @click="confirm">确认删除</el-button>
        <el-button type="default" size="medium" @click="dialogVisible = false">取消</el-button>
    </div>
  </dialog-template>
</template>

<script>
// import DialogTemplate from "./dialog_template";
export default {
  data() {
    return {
      dialogVisible: false,
      options: {}
    }
  },
  props: {
      loading: Boolean
  },
  methods: {
    open(options = {}) {
      this.options = options
      this.dialogVisible = true
    },

    confirm() {
        this.options.callback && this.options.callback(() => this.dialogVisible = false)
    }
  }
}
</script>

<style lang="scss" scoped>
p {
    text-align: center;
}

.question {
    height: 20px;
    line-height: 20px;
    color: #333;
    font-size: 14px;
    font-weight: 500;

    span {
        font-weight: bold;
    }
}

.tips {
    height: 16px;
    line-height: 16px;
    margin-top: 8px;
    font-size: 12px;
    color: #666;
}

.btn-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
